module.exports = __webpack_public_path__ + "static/media/icon-alert.e10be4ca.svg";